import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "wapper"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_select_position = _resolveComponent("select-position");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", null, "可投放点位：", -1)), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, pos => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: pos.id
    }, [_createElementVNode("i", {
      class: "el-icon-remove",
      onClick: $event => $setup.deletePos(pos.id)
    }, null, 8, _hoisted_2), _createTextVNode(" " + _toDisplayString(pos.posAllName), 1)]);
  }), 128)), _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "plus",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.addPos && $setup.addPos(...args))
  }, [...(_cache[1] || (_cache[1] = [_createElementVNode("i", {
    class: "el-icon-circle-plus"
  }, null, -1), _createTextVNode("添加可投放点位", -1)]))])), [[_directive_has, 'asset:lib:position:add']]), _createVNode(_component_select_position, {
    ref: "selectPositionRef",
    onOk: $setup.stPosOk
  }, null, 8, ["onOk"])])]);
}